import * as React from "react";
import { Icon } from "../actions/Icon";

/**
 * Pill label for status, kind, visibility and platform. Tones map to meaning: accent = recording kind/info, now = meeting/upcoming, success = done, record = live/external.
 */
export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?:
    | "neutral"
    | "private"
    | "shared"
    | "processing"
    | "accent"
    | "now"
    | "now-solid"
    | "record"
    | "success"
    | "inverse"
    | "meet"
    | "zoom"
    | "teams"
    | "outline"
    | "glass";
  size?: "sm" | "md" | "lg";
  icon?: string;
  /** Leading status dot */
  dot?: boolean;
  children?: React.ReactNode;
}

export function Badge({ tone = "neutral", size = "md", icon, dot, className, children, ...rest }: BadgeProps): JSX.Element {
  const cls = ["gk-badge", "gk-badge--" + tone, size !== "md" && "gk-badge--" + size, className].filter(Boolean).join(" ");
  return (
    <span className={cls} {...rest}>
      {dot && <span className="gk-badge__dot" />}
      {icon && <Icon name={icon} size={size === "sm" ? 13 : 14} />}
      {children !== undefined && children !== null && <span className="gk-badge__label">{children}</span>}
    </span>
  );
}
